<template>
  <div>
    <avue-crud
      :data="data"
      :option="option"
      @row-save="create"
      @row-update="update"
      @row-del="remove"
      :page.sync="page"
      @on-load="changPage"
      @search-change="search"
    >
      <template #menu="{ type, size, row }">
        <el-button
          :type="type"
          :size="size"
          icon="el-icon-s-operation"
          @click="openItemDrawer(row)"
        >子项管理</el-button>
      </template>
    </avue-crud>

    <el-drawer
      :title="itemDrawerTitle"
      :visible.sync="itemDrawerVisible"
      size="60%"
      :before-close="closeItemDrawer"
    >
      <div class="item-drawer-body">
        <div class="item-drawer-header">
          <el-input
            v-model="itemQuery.keyword"
            placeholder="搜索 code / 名称"
            size="small"
            clearable
            style="width: 240px"
            @keyup.enter.native="fetchItems"
            @clear="fetchItems"
          />
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="fetchItems"
          >搜索</el-button>
          <el-tooltip
            v-if="!hasPermission('dict:item:add')"
            content="暂无新增权限"
            placement="top"
          >
            <span>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-plus"
                disabled
              >新增子项</el-button>
            </span>
          </el-tooltip>
          <el-button
            v-else
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="openItemForm(null)"
          >新增子项</el-button>
        </div>

        <el-table
          :data="itemData"
          stripe
          border
          style="width: 100%"
          @sort-change="handleItemSortChange"
        >
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="code" label="字典 code" sortable="custom" min-width="140" />
          <el-table-column prop="name" label="名称" sortable="custom" min-width="140" />
          <el-table-column prop="sort" label="排序值" sortable="custom" width="100" align="center" />
          <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status ? 'success' : 'danger'" size="small">
                {{ scope.row.status ? '启用' : '禁用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-tooltip
                v-if="!hasPermission('dict:item:edit')"
                content="暂无编辑权限"
                placement="top"
              >
                <span>
                  <el-button type="text" size="small" icon="el-icon-edit" disabled>编辑</el-button>
                </span>
              </el-tooltip>
              <el-button
                v-else
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="openItemForm(scope.row)"
              >编辑</el-button>
              <el-tooltip
                v-if="!hasPermission('dict:item:delete')"
                content="暂无删除权限"
                placement="top"
              >
                <span>
                  <el-button type="text" size="small" icon="el-icon-delete" style="color: #f56c6c" disabled>删除</el-button>
                </span>
              </el-tooltip>
              <el-button
                v-else
                type="text"
                size="small"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click="removeItem(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="item-pagination"
          @size-change="handleItemSizeChange"
          @current-change="handleItemCurrentChange"
          :current-page="itemPage.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="itemPage.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="itemPage.total"
        />
      </div>
    </el-drawer>

    <el-dialog
      :title="itemFormTitle"
      :visible.sync="itemFormVisible"
      width="500px"
      :before-close="closeItemForm"
    >
      <el-form
        ref="itemForm"
        :model="itemForm"
        :rules="itemFormRules"
        label-width="100px"
        size="small"
      >
        <el-form-item label="字典 code" prop="code">
          <el-input v-model="itemForm.code" placeholder="请输入字典 code" :disabled="!!editingItemId" />
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="itemForm.name" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input-number v-model="itemForm.sort" :min="0" :step="1" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="itemForm.status" active-text="启用" inactive-text="禁用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="closeItemForm">取消</el-button>
        <el-button type="primary" size="small" @click="submitItemForm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      query: {
        limit: 10,
      },
      page: {
        total: 0,
      },
      data: [],
      option: {
        border: true,
        index: true,
        searchMenuSpan: 5,
        indexLabel: "序号",
        translate: false,
        column: [
          {
            label: "选项类型",
            prop: "type",
            props: {
              label: "label",
              value: "value",
            },
            span: 12,
            dicUrl: `type/name`,
            type: "select",
            search: true,
            rules: [
              {
                required: true,
                message: "请选择类型",
                trigger: "blur",
              },
            ],
          },
          {
            label: "选项名",
            prop: "label",
            span: 12,
            search: true,
            rules: [
              {
                required: true,
                message: "请输入选项名",
                trigger: "blur",
              },
            ],
          },
          {
            label: "显示名",
            prop: "displayName",
            span: 12,
            rules: [
              {
                required: true,
                message: "请输入显示名",
                trigger: "blur",
              },
            ],
          },
          {
            label: "存储值",
            prop: "value",
            type: "number",
          },
          {
            label: "子项数量",
            prop: "childrenCount",
            width: 100,
            editDisplay: false,
            addDisplay: false,
          },
        ],
      },
      itemDrawerVisible: false,
      currentDict: null,
      itemQuery: {
        keyword: "",
        sortField: "",
        sortOrder: "",
      },
      itemPage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      itemData: [],
      itemFormVisible: false,
      editingItemId: null,
      itemForm: {
        code: "",
        name: "",
        sort: 0,
        status: true,
      },
      itemFormRules: {
        code: [
          { required: true, message: "请输入字典 code", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        sort: [
          { type: "integer", message: "排序值必须为整数", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    itemDrawerTitle() {
      if (this.currentDict) {
        return `子项管理 - ${this.currentDict.label || this.currentDict.type}`;
      }
      return "子项管理";
    },
    itemFormTitle() {
      return this.editingItemId ? "编辑子项" : "新增子项";
    },
  },
  methods: {
    hasPermission(point) {
      if (this.user.role === 0) return true;
      if (this.user.permissions && Array.isArray(this.user.permissions)) {
        return this.user.permissions.includes(point);
      }
      return false;
    },
    async changPage({ pageSize, currentPage }) {
      this.query.page = currentPage;
      this.query.limit = pageSize;
      this.fetch();
    },
    search(where, done) {
      done();
      if (where.label) {
        where.label = { $regex: where.label };
      }
      this.query.where = where;
      this.fetch();
    },
    async fetch() {
      const res = await this.$http.get("dictionaries", {
        params: {
          query: this.query,
        },
      });
      this.page.total = res.data.total;
      this.data = res.data.data;
    },
    async remove(row) {
      try {
        await this.$confirm("是否确认删除？");
      } catch (e) {
        return;
      }
      await this.$http.delete(`dictionaries/${row._id}`);
      this.$message.success("删除成功");
      this.fetch();
    },
    async update(row, index, done) {
      await this.$http.put(`dictionaries/${row._id}`, row);
      this.$message.success("更新成功");
      this.fetch();
      done();
    },
    async create(row, done) {
      await this.$http.post("dictionaries", row);
      this.$message.success("创建成功");
      this.fetch();
      done();
    },
    async openItemDrawer(row) {
      this.currentDict = row;
      this.itemDrawerVisible = true;
      this.itemPage.currentPage = 1;
      this.itemQuery.keyword = "";
      this.itemQuery.sortField = "";
      this.itemQuery.sortOrder = "";
      await this.fetchItems();
    },
    async closeItemDrawer() {
      this.itemDrawerVisible = false;
      this.currentDict = null;
      this.itemData = [];
      this.itemPage.total = 0;
      this.fetch();
    },
    async fetchItems() {
      if (!this.currentDict) return;
      const params = {
        dictId: this.currentDict._id,
        page: this.itemPage.currentPage,
        limit: this.itemPage.pageSize,
      };
      if (this.itemQuery.keyword) {
        params.keyword = this.itemQuery.keyword;
      }
      if (this.itemQuery.sortField) {
        params.sortField = this.itemQuery.sortField;
        params.sortOrder = this.itemQuery.sortOrder;
      }
      const res = await this.$http.get("dict-items", { params });
      this.itemData = res.data.data || [];
      this.itemPage.total = res.data.total || 0;
    },
    handleItemSortChange(sortInfo) {
      if (sortInfo.prop) {
        this.itemQuery.sortField = sortInfo.prop;
        this.itemQuery.sortOrder = sortInfo.order === "ascending" ? "asc" : "desc";
      } else {
        this.itemQuery.sortField = "";
        this.itemQuery.sortOrder = "";
      }
      this.itemPage.currentPage = 1;
      this.fetchItems();
    },
    handleItemSizeChange(size) {
      this.itemPage.pageSize = size;
      this.itemPage.currentPage = 1;
      this.fetchItems();
    },
    handleItemCurrentChange(page) {
      this.itemPage.currentPage = page;
      this.fetchItems();
    },
    openItemForm(row) {
      if (row) {
        this.editingItemId = row._id;
        this.itemForm = {
          code: row.code,
          name: row.name,
          sort: row.sort,
          status: row.status,
        };
      } else {
        this.editingItemId = null;
        this.itemForm = {
          code: "",
          name: "",
          sort: 0,
          status: true,
        };
      }
      this.itemFormVisible = true;
    },
    closeItemForm() {
      this.itemFormVisible = false;
      this.editingItemId = null;
      this.$refs.itemForm && this.$refs.itemForm.clearValidate();
    },
    async submitItemForm() {
      const valid = await this.$refs.itemForm.validate().catch(() => false);
      if (!valid) return;
      const data = {
        ...this.itemForm,
        dictId: this.currentDict._id,
      };
      if (this.editingItemId) {
        await this.$http.put(`dict-items/${this.editingItemId}`, data);
        this.$message.success("更新成功");
      } else {
        await this.$http.post("dict-items", data);
        this.$message.success("创建成功");
      }
      this.closeItemForm();
      await this.fetchItems();
    },
    async removeItem(row) {
      if (!this.hasPermission("dict:item:delete")) return;
      try {
        await this.$confirm("是否确认删除该子项？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (e) {
        return;
      }
      try {
        await this.$http.delete(`dict-items/${row._id}`);
        this.$message.success("删除成功");
        await this.fetchItems();
      } catch (err) {
        const status = this._.get(err, "response.status");
        if (status === 409) {
          this.$message.error("已引用，不可删除");
        } else {
          this.$message.error("删除失败");
        }
      }
    },
  },
  created() {
    this.fetch();
  },
};
</script>

<style scoped>
.item-drawer-body {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.item-drawer-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.item-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
